import { cva as e } from "class-variance-authority";
// src/design/accordion/styles.ts
var t = e("flex text-foreground", {
	variants: {
		orientation: {
			horizontal: "flex-row h-80 max-h-[calc(100vh-8rem)]",
			vertical: "flex-col w-full max-w-md"
		},
		variant: {
			default: "",
			bordered: "border border-border rounded-lg overflow-hidden",
			card: "bg-card rounded-lg shadow-sm"
		}
	},
	defaultVariants: {
		orientation: "vertical",
		variant: "default"
	}
}), n = e("overflow-anchor-none w-full", {
	variants: {
		orientation: {
			horizontal: "flex border-r border-border last:border-r-0",
			vertical: "block border-b border-border last:border-b-0"
		},
		variant: {
			default: "",
			bordered: "",
			card: "first:rounded-t-lg last:rounded-b-lg"
		}
	},
	defaultVariants: {
		orientation: "vertical",
		variant: "default"
	}
}), r = e([
	"flex items-center justify-between gap-3",
	"bg-transparent border-none m-0",
	"text-sm font-semibold leading-normal text-start text-foreground",
	"outline-hidden cursor-pointer",
	"transition-colors duration-fast",
	"hover:bg-muted/50",
	"focus-ring-inset",
	"data-[disabled]:opacity-50 data-[disabled]:grayscale data-[disabled]:cursor-not-allowed"
], {
	variants: {
		orientation: {
			horizontal: "h-full min-w-10 px-2 [writing-mode:sideways-lr]",
			vertical: "w-full min-h-7 px-2"
		},
		size: {
			sm: "",
			md: "",
			lg: ""
		}
	},
	compoundVariants: [
		{
			orientation: "vertical",
			size: "sm",
			class: "min-h-7 px-2 text-sm"
		},
		{
			orientation: "vertical",
			size: "md",
			class: "min-h-8 px-3 text-sm"
		},
		{
			orientation: "vertical",
			size: "lg",
			class: "min-h-10 px-4 text-base"
		},
		{
			orientation: "horizontal",
			size: "sm",
			class: "min-w-7 px-1.5 text-sm"
		},
		{
			orientation: "horizontal",
			size: "md",
			class: "min-w-8 px-2 text-sm"
		},
		{
			orientation: "horizontal",
			size: "lg",
			class: "min-w-10 px-3 text-base"
		}
	],
	defaultVariants: {
		orientation: "vertical",
		size: "sm"
	}
}), i = e([
	"inline-flex items-center justify-center",
	"text-foreground",
	"transition-transform duration-normal ease-enter origin-center",
	"data-[state=open]:rotate-180",
	"[&>svg]:w-[1.2em] [&>svg]:h-[1.2em] [&>svg]:shrink-0"
], {
	variants: { size: {
		sm: "[&>svg]:w-4 [&>svg]:h-4",
		md: "[&>svg]:w-5 [&>svg]:h-5",
		lg: "[&>svg]:w-6 [&>svg]:h-6"
	} },
	defaultVariants: { size: "sm" }
}), a = e([
	"overflow-hidden rounded-sm",
	"data-[state=open]:data-[orientation=vertical]:animate-accordion-down",
	"data-[state=closed]:data-[orientation=vertical]:animate-accordion-up",
	"data-[state=open]:data-[orientation=horizontal]:animate-accordion-right",
	"data-[state=closed]:data-[orientation=horizontal]:animate-accordion-left",
	"data-[orientation=horizontal]:whitespace-nowrap"
], {
	variants: { variant: {
		default: "",
		bordered: "",
		card: "bg-card"
	} },
	defaultVariants: { variant: "default" }
}), o = e("text-foreground leading-relaxed", {
	variants: { size: {
		sm: "px-2 pb-2 text-xs",
		md: "px-3 pb-3 text-sm",
		lg: "px-4 pb-4 text-base"
	} },
	defaultVariants: { size: "md" }
});
function s(e) {
	let s = e?.orientation ?? "vertical", c = e?.variant ?? "default", l = e?.size ?? "sm";
	return {
		root: (e) => t({
			orientation: s,
			variant: c,
			...e
		}),
		item: (e) => n({
			orientation: s,
			variant: c,
			...e
		}),
		itemTrigger: (e) => r({
			orientation: s,
			size: l,
			...e
		}),
		itemIndicator: (e) => i({
			size: l,
			...e
		}),
		itemContent: (e) => a({
			variant: c,
			...e
		}),
		itemBody: (e) => o({
			size: l,
			...e
		})
	};
}
export { s as getStyles, o as itemBodyStyles, a as itemContentStyles, i as itemIndicatorStyles, n as itemStyles, r as itemTriggerStyles, t as rootStyles };

//# sourceMappingURL=styles.js.map